var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../../app';
import { Component } from '../../../lib/dom';
import { PHRASES, t } from '../../../translate';
import { playerAvatar } from './playerAvatar';
import './Entry.less';
var Entry = /** @class */ (function (_super) {
    __extends(Entry, _super);
    function Entry(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Entry';
        _this.el = _this.getEl();
        return _this;
    }
    Entry.prototype.getEl = function () {
        var _a = this.props, entry = _a.entry, header = _a.header;
        var rank = String(entry.rank);
        return this.DIV(this.getClassName(this.props), [
            this.DIV(rank.length > 3 ? '&__rank &__rank_1000' : '&__rank', [this.DIV({}, rank)]),
            this.DIV('&__avatar', [this.DIV('&__avatar-img', [header ? entry.player.avatar : playerAvatar(entry.player)])]),
            this.DIV({
                className: '&__name',
                // @ts-ignore
                onClick: DEVELOPMENT ? function () { return window['openAuthAsModal'](entry.player.publicName); } : undefined,
            }, this.getName()),
            this.DIV('&__score', [this.DIV({}, [App.Fn.getScoreString(entry.score)])]),
        ]);
    };
    Entry.prototype.getName = function () {
        var _this = this;
        var _a = this.props, entry = _a.entry, splitName = _a.splitName;
        var name = entry.player.publicName || t(PHRASES.Anonymous_player);
        if (splitName) {
            var nameArr = name.split(' ');
            if (nameArr.length === 2) {
                return nameArr.map(function (s) { return _this.DIV({}, [s]); });
            }
        }
        return [name];
    };
    Entry.prototype.getClassName = function (props) {
        var className = ['&'];
        props.header && className.push('Header');
        props.active && className.push('&_active');
        props.border && className.push('&_withBorder');
        return className.join(' ');
    };
    return Entry;
}(Component));
export { Entry };
